"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const async_storage_1 = __importDefault(require("@react-native-async-storage/async-storage"));
const set = async (name, value) => {
    try {
        return await async_storage_1.default.setItem(name, value);
    }
    catch (e) {
        // save error
    }
};
const get = async (key) => {
    try {
        const value = await async_storage_1.default.getItem(key);
        if (value !== null) {
            return value;
        }
    }
    catch (e) {
        return "";
    }
};
const remove = async (key) => {
    try {
        await async_storage_1.default.removeItem(key);
        return true;
    }
    catch (exception) {
        return false;
    }
};
exports.default = {
    set,
    get,
    remove,
};
